export enum EventUpdateStrategy {
	Periodically = 2,
	Stepwise = 3,
}
